import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackagesComponent } from './packages-ang7';
import { PackagesVersionsModule } from "./packages-versions/packages-versions.module";
import { PackagesListModule } from "./packages-list/packages-list.module";

@NgModule({
    imports: [SharedModule,PackagesVersionsModule,PackagesListModule],
    declarations: [PackagesComponent],
    entryComponents: [PackagesComponent],
    exports: [PackagesComponent]
})
export class PackagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages.module.ts